<div class="verify-otp-container">
	<ngx-ui-loader loaderId="verify-otp-submit-loader" fgsType="fading-circle" fgsColor="#dc2626"
		fgsPosition="center-center" overlayColor="rgba(0,0,0,0.5)">
	</ngx-ui-loader>

	<div class="otp-header">
		<h3 class="text-xl font-semibold text-gray-800 mb-2">Vérification OTP</h3>
		<p class="text-sm text-gray-600 mb-4">
			Nous avons envoyé un code de vérification au numéro
			<span class="font-medium">{{ indicative }} {{ phoneNumber }}</span>
		</p>
	</div>

	<form [formGroup]="otpForm" (ngSubmit)="onSubmit()" class="otp-form">
		<div class="mb-6">
			<label class="block text-gray-700 mb-2 text-sm font-medium">Code OTP</label>
			<input type="text" formControlName="otpCode" placeholder="Entrez le code à 6 chiffres"
				class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
				[class.border-red-500]="submitted && otpForm.get('otpCode')?.invalid" maxlength="6"
				autocomplete="one-time-code">

			<div *ngIf="submitted && otpForm.get('otpCode')?.errors?.['required']" class="text-red-500 text-sm mt-1">
				Le code OTP est requis.
			</div>
			<div *ngIf="submitted && otpForm.get('otpCode')?.errors?.['minlength']" class="text-red-500 text-sm mt-1">
				Le code OTP doit contenir au moins 4 chiffres.
			</div>
		</div>

		<button type="submit"
			class="w-full bg-red-600 text-white py-3 px-4 rounded-lg hover:bg-red-700 transition-colors font-medium"
			[disabled]="loading || otpForm.invalid">
			<span *ngIf="!loading">Vérifier le code</span>
			<span *ngIf="loading">Vérification en cours...</span>
		</button>
	</form>

	<div class="mt-6 text-center">
		<p class="text-sm text-gray-600 mb-2">
			Vous n'avez pas reçu le code ?
		</p>

		<div *ngIf="!canResend" class="text-sm text-gray-500">
			Renvoyer dans {{ formatTime(remainingTime) }}
		</div>

		<button *ngIf="canResend" (click)="resendOtp()" [disabled]="loading"
			class="text-red-600 hover:text-red-700 text-sm font-medium underline">
			Renvoyer le code
		</button>
	</div>
</div>